import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, User } from "react-feather";

import { LI, UL, P } from "../../../AbstractElements";
import { LogOut, MyProfile } from "../../../Constant";
import { fetchCurrentUser, getStoredUser, logout } from "../../../api/auth";
import CustomizerContext from "../../../_helper/Customizer";

const UserHeader = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const [name, setName] = useState("Staff User");
  const [role, setRole] = useState("");

  useEffect(() => {
    const stored = getStoredUser();
    if (stored) {
      setName(stored.full_name);
      setRole(stored.role?.replace(/_/g, " ") || "");
      return;
    }

    fetchCurrentUser()
      .then((user) => {
        localStorage.setItem("credora_user", JSON.stringify(user));
        setName(user.full_name);
        setRole(user.role?.replace(/_/g, " ") || "");
      })
      .catch(() => {});
  }, []);

  const handleAccount = () => {
    history(`${process.env.PUBLIC_URL}/credora/account/${layoutURL}`);
  };

  const handleLogout = () => {
    logout();
    history(`${process.env.PUBLIC_URL}/login`);
  };

  return (
    <li className="profile-nav credora-profile-nav onhover-dropdown pe-0">
      <div className="media profile-media">
        <span className="credora-profile-nav__avatar" aria-hidden="true">
          <User size={18} strokeWidth={2} />
        </span>
        <div className="media-body">
          <span>{name}</span>
          <P attrPara={{ className: "mb-0 font-roboto text-capitalize" }}>
            {role || "Credora360"} <i className="middle fa fa-angle-down"></i>
          </P>
        </div>
      </div>
      <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}>
        <LI attrLI={{ onClick: handleAccount }}>
          <User />
          <span>{MyProfile}</span>
        </LI>
        <LI attrLI={{ onClick: handleLogout }}>
          <LogIn />
          <span>{LogOut}</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
